module.exports = __webpack_public_path__ + "static/media/XXIh.50c785dc.png";